export function scrubbingStatusClassNameColumn(status: string): string {
  if (status === 'Incomplete') return 'text--orange';
  if (status === 'Passed') return 'text--green';
  if (status === 'Disqualified') return 'text--red';
  if (status === 'Pending') return 'text--blue';
  if (status === 'Pending-Disqualified') return 'text--orange';
  return '';
}
